import VueEasyLightbox from 'vue-easy-lightbox'
import Vue from 'vue'

Vue.use(VueEasyLightbox)